'use client'

import { useTranslation } from 'react-i18next'
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card'

export const SandboxTestingInfoCard = () => {
    const { t } = useTranslation('processors')

    return (
        <Card className="mb-6">
            <CardHeader>
                <CardTitle>{t('testingInformation')}</CardTitle>
            </CardHeader>
            <CardContent>
                <div className="space-y-4">
                    <div className="rounded-lg bg-blue-50 p-4 border border-blue-200">
                        <h4 className="mb-2 text-sm font-medium text-blue-800">
                            🧪 {t('sandboxEnvironment')}
                        </h4>
                        <ul className="list-disc space-y-1 pl-4 text-sm text-blue-700">
                            <li>{t('sandboxFeature1')}</li>
                            <li>{t('sandboxFeature2')}</li>
                            <li>{t('sandboxFeature3')}</li>
                            <li>{t('sandboxFeature4')}</li>
                        </ul>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div className="rounded-lg bg-green-50 p-4 border border-green-200">
                            <h4 className="mb-2 text-sm font-medium text-green-800">
                                ✅ {t('successfulTestCards')}
                            </h4>
                            <div className="space-y-1 text-sm text-green-700">
                                <div className="font-mono">4242424242424242</div>
                                <div className="font-mono">5555555555554444</div>
                                <div className="font-mono">378282246310005</div>
                                <p className="text-xs mt-2">{t('successfulCardsNote')}</p>
                            </div>
                        </div>

                        <div className="rounded-lg bg-red-50 p-4 border border-red-200">
                            <h4 className="mb-2 text-sm font-medium text-red-800">
                                ❌ {t('declinedTestCards')}
                            </h4>
                            <div className="space-y-1 text-sm text-red-700">
                                <div className="font-mono text-xs">4000000000000002 - {t('genericDecline')}</div>
                                <div className="font-mono text-xs">4000000000009995 - {t('insufficientFunds')}</div>
                                <div className="font-mono text-xs">4000000000000069 - {t('expiredCard')}</div>
                                <p className="text-xs mt-2">{t('declinedCardsNote')}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </CardContent>
        </Card>
    )
}

